import React, {FunctionComponent, useState, useEffect, useMemo, useCallback} from "react"
import {debounce} from "lodash"

interface TextareaProps {
	title: string
	disabled?: boolean
	placeholder?: string
	value?: string
	fieldId: string
	onSubmit: (val: string, fieldId: string) => void
}

const Textarea: FunctionComponent<TextareaProps> = ({
	title,
	disabled = false,
	value,
	placeholder,
	fieldId,
	onSubmit
}) => {
	const [text, setText] = useState(value)

	useEffect(() => {
		setText(value)
	}, [value])

	const debouncedSlider = useMemo(
		() =>
			debounce(val => {
				onSubmit(val, fieldId)
			}, 2000),
		[onSubmit]
	)

	const handleChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
		e.preventDefault()
		setText(e.target.value)
		debouncedSlider(e.target.value)
	}, [])

	return (
		<div className='event-input-wrapper'>
			<div className='event-block-title'>
				<label htmlFor={fieldId}>{title}</label>
			</div>
			<div className='field-message-wrapper'>
				<textarea
					placeholder={placeholder}
					id={fieldId}
					rows={3}
					name={fieldId}
					disabled={disabled}
					value={text}
					onChange={handleChange}
				/>
			</div>
		</div>
	)
}

export default Textarea
